function NoticeBanner({ children, tone = "info" }) {
  return <div className={`notice-banner notice-banner-${tone}`}>{children}</div>;
}

export default NoticeBanner;
